import Vue from "vue";
import moment from "moment";

Vue.filter("formatTime", (time) => {
  return moment(time).format("h:mm a");
});

Vue.filter("formatDate", (date) => {
  if (date) {
    return moment(date).format("MMM DD");
  } else {
    return "n/a";
  }
});

Vue.filter("formatDateYear", (date) => {
  if (date) {
    return moment(date).format("MMM DD, YYYY");
  } else {
    return "n/a";
  }
});

Vue.filter("formatDateTime", (date) => {
  if (date) {
    return moment(date).format("MMM DD hh:mm a");
  } else {
    return "n/a";
  }
});

Vue.filter("formatNumber", (val) => {
  if (val) {
    return val.toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  } else {
    return "0";
  }
});
